import React, { useEffect } from "react";
import accordionInit from "./accordion";
import { util } from "./util";
import LazyImage from "./lazyImage";

const ProductDescription = ({ details, currentProduct }) => {
  const htmlContent = details.description;
  useEffect(() => {
    accordionInit.init();
  }, []);
  
  return (
    <>
      <p
        className="product__tip type"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
      {currentProduct?.handle !== "gift-wrap" && (
        <div className="giftwrap-cta">
          <a className="add-gw-cta" href="/products/gift-wrap">
            Add Gift Wrap
          </a>
        </div>
      )}

      <div class="weezie-guarantee-wrapper">
        <div class="weezie-guarantee">
          <h3>Our Promise</h3>
          <p>
            <span>Wowed, or we'll make it right.</span>If for any reason you’re
            not 100% wowed by Weezie,{" "}
            <a href="mailto:holler@weezietowels.com">holler</a> and we’ll make
            it right.
          </p>
        </div>
      </div>
      <div className="product__accordions">
        {details?.accordionTitle?.map((title, index) => (
          <div className="accordion" key={index}>
            <button
              className="accordion__title type"
              data-cc={`accordion-${index}`}
            >
              {title}
            </button>
            <div
              className="accordion__content"
              dangerouslySetInnerHTML={{
                __html: details.accordionContent[index] || "",
              }}
            />
          </div>
        ))}
      </div>
      {/* upsell */}
      {details?.upsellPrice&&   <a href={details?.upsellLink} className="upsell-card">
        <div className="upsell-card__image">
          {/* Replace with your image rendering logic */}
          <LazyImage
            imageBase={{ url: details.upsellImage, width: 800, height: 600 }}
            altText="Example Image"
            srcs="300x,400x,500x,600x,800x"
            type="color"
            sizes="100vw"
            ratio="16x9"
          />
        </div>

        <div className="upsell-card__meta">
          <p className="upsell-card__label type">Make it a set!</p>
          <p className="upsell-card__title x-small">{details?.upsellTitle}</p>
          <p className="upsell-card__price type">
            Starting at {util?.formatMoney(details?.upsellPrice)}
          </p>
        </div>
      </a>}
    </>
  );
};

export default ProductDescription;
